import alert from '../../../../../../modules/VerzekeringsInzicht/App/alert.js';
import conditioneleVragen from '../../../../../../modules/VerzekeringsInzicht/App/conditioneleVragen.js';
import opbouwschema from '../../../../../../modules/VerzekeringsInzicht/App/opbouwschema.js';
import popover from '../../../../../../modules/VerzekeringsInzicht/App/popover.js';
import verloopModal from '../../../../../../modules/VerzekeringsInzicht/App/verloopModal.js';

const werkgeverPeriodiek = {
	/**
	 * Initializes form function
	 *
	 * @returns {void}
	 */
	init: function () {
		alert.init();
		conditioneleVragen.init();
		opbouwschema.init();
		popover.init();
		verloopModal.init();
	},
};

export default werkgeverPeriodiek;
